export const ADMIN_PAGE_META = {
  dashboard: {
    title: "Dashboard",
    subtitle:
      "See how bookings and payments are doing at a glance. Pick a time range, then scroll for details.",
  },
  suppliers: {
    title: "Suppliers",
    subtitle: "Manage supplier registrations, approvals, and account details.",
  },
  users: {
    title: "Users",
    subtitle: "View and manage registered website users.",
  },
  enquiry: {
    title: "Enquiries",
    subtitle: "Review customer package enquiries and mark them as read.",
  },
  bookings: {
    title: "Bookings Management",
    subtitle:
      "Manage package, event, attraction, activity, and rental bookings across the platform.",
  },
  packages: {
    title: "Packages",
    subtitle: "Review and manage tour packages submitted by suppliers.",
  },
  events: {
    title: "Events",
    subtitle: "Review and manage events listed on the platform.",
  },
  attractions: {
    title: "Attractions",
    subtitle: "Review and manage attractions listed on the platform.",
  },
  supplierActivities: {
    title: "Supplier Activities",
    subtitle: "Review supplier activities and approve or reject submissions.",
  },
  rentals: {
    title: "Rentals",
    subtitle: "Review supplier rentals and approve or reject listings.",
  },
  rentalManagement: {
    title: "Rental management",
    subtitle: "Manage currently booked rental items.",
  },
  activities: {
    title: "Activities",
    subtitle: "Manage activity master data used across the platform.",
  },
  countries: {
    title: "Countries",
    subtitle: "Manage countries and their display order.",
  },
  states: {
    title: "States",
    subtitle: "Manage states and their display order.",
  },
  destinations: {
    title: "Destinations",
    subtitle: "Manage travel destinations and featured listings.",
  },
  meals: {
    title: "Meals",
    subtitle: "Manage meal options and display order.",
  },
  suitable: {
    title: "Suitable For",
    subtitle: "Manage suitable-for options used in package listings.",
  },
  inclusions: {
    title: "Inclusions",
    subtitle: "Manage inclusion master data and display order.",
  },
  eventTicketTypes: {
    title: "Event Ticket Types",
    subtitle: "Manage event ticket type master data.",
  },
  eventCategory: {
    title: "Event Categories",
    subtitle: "Manage event category master data.",
  },
  activityCategory: {
    title: "Activity Categories",
    subtitle: "Platform-wide activity categories used by all suppliers.",
  },
  attractionCategory: {
    title: "Attraction Categories",
    subtitle: "Platform-wide attraction categories used by all suppliers.",
  },
  language: {
    title: "Languages",
    subtitle: "Manage supported languages on the platform.",
  },
  transactions: {
    title: "Transactions",
    subtitle: "View payment transactions across all services.",
  },
  settings: {
    title: "Settings",
    subtitle: "Update your admin account settings.",
  },
};
